"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const renderer_1 = require("@react-pdf/renderer");
const styles = renderer_1.StyleSheet.create({
    logo: {
        width: 98.5,
        height: 70,
        marginLeft: 0,
        marginRight: 75,
    },
    titleContainer: {
        flexDirection: 'row',
        marginTop: 0,
    },
    reportTitle: {
        color: 'black',
        letterSpacing: 4,
        fontSize: 25,
        textAlign: 'left',
        textTransform: 'uppercase',
        marginTop: 24,
    },
});
const InvoiceTitle = ({ title }) => (react_1.default.createElement(renderer_1.View, { style: styles.titleContainer },
    react_1.default.createElement(renderer_1.Image, { style: styles.logo, src: "/images/logo.png" }),
    react_1.default.createElement(renderer_1.Text, { style: styles.reportTitle }, title)));
exports.default = InvoiceTitle;
